import { CustomMultiSelectModel } from "../../../components/CustomMultiSelect"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetVehicleTypeListPagingAndFilterRequest {
    searchTerm: string
    skip: number
    take: number
    selectedCompanies: CustomMultiSelectModel[]
    currentPage: number
    /** Kolon başlıklarının altındaki filtreler (liste tarayıcıda süzülür, sunucuya gitmez). */
    columnFilters: ColumnFilterModel[]
}

export const initialGetVehicleTypeListPagingAndFilterRequest: GetVehicleTypeListPagingAndFilterRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    selectedCompanies: [],
    currentPage: 1,
    columnFilters: []
}